import Swiper from 'swiper';
// import 'remodal';

// スクロール
var Ease = {
	easeInOut: (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1),
};
var duration = 500;
window.addEventListener('DOMContentLoaded', () => {
	var smoothScrollTriggers = document.querySelectorAll('.anchor');
	smoothScrollTriggers.forEach(function (smoothScrollTrigger) {
		smoothScrollTrigger.addEventListener('click', function (e) {
			var href = smoothScrollTrigger.getAttribute('href');
			var currentPostion = document.documentElement.scrollTop || document.body.scrollTop;
			var targetElement = document.getElementById(href.replace('#', ''));
			if (targetElement) {
				e.preventDefault();
				e.stopPropagation();
				var targetPosition = window.pageYOffset + targetElement.getBoundingClientRect().top - 0;
				var startTime = performance.now();
				var loop = function (nowTime) {
					var time = nowTime - startTime;
					var normalizedTime = time / duration;
					if (normalizedTime < 1) {
						window.scrollTo(0, currentPostion + (targetPosition - currentPostion) * Ease.easeInOut(normalizedTime));
						requestAnimationFrame(loop);
					} else {
						window.scrollTo(0, targetPosition);
					}
				};
				requestAnimationFrame(loop);
			}
		});
	});

	// スライダー
	let slide = document.querySelectorAll('.slide');
	const swiperInstances = new Map();
	const stoppedSwipers = new Set(); // 一度停止したスライダーを記録
	
	for (let i = 0; i < slide.length; i++) {
		const swiperContainer = slide[i].querySelector('.swiper-container');
		if (!swiperContainer) continue;
		
		// 親セクションを確認して、LOOK2、LOOK5、LOOK10、LOOK13でflipエフェクトを使用
		const parentSection = slide[i].closest('.ptn');
		const isFlipTarget = parentSection && (parentSection.classList.contains('style2') || parentSection.classList.contains('style5') || parentSection.classList.contains('style10') || parentSection.classList.contains('style13'));
		
		const swiperConfig = {
			loop: true,
			speed: 800,
			autoplay: {
				delay: 3500,
				disableOnInteraction: false,
				waitForTransition: false,
			},
		};
		
		// LOOK2、LOOK5、LOOK10、LOOK13でflipエフェクトを使用
		if (isFlipTarget) {
			swiperConfig.effect = 'flip';
			swiperConfig.flipEffect = {
				slideShadows: true,
				limitRotation: true,
			};
		}
		
		const swiperInstance = new Swiper(swiperContainer, swiperConfig);
		// スライダーコンテナをキーとしてインスタンスを保存
		swiperInstances.set(swiperContainer, swiperInstance);
	}

	// LOOK2、LOOK5、LOOK10のスライダーが表示されたらautoplayを停止（一度だけ）
	const targetSections = document.querySelectorAll('.style2, .style5, .style10');
	const stopAutoplayObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// 表示されたセクション内のスライダーを探す
				const slideElement = entry.target.querySelector('.slide');
				if (slideElement) {
					const swiperContainer = slideElement.querySelector('.swiper-container');
					if (swiperContainer && swiperInstances.has(swiperContainer)) {
						// まだ停止していない場合のみ停止
						if (!stoppedSwipers.has(swiperContainer)) {
							const swiperInstance = swiperInstances.get(swiperContainer);
							if (swiperInstance && swiperInstance.autoplay) {
								swiperInstance.autoplay.stop();
								stoppedSwipers.add(swiperContainer); // 停止済みとして記録
								// このセクションの監視を停止（一度表示されたら二度と回転しない）
								stopAutoplayObserver.unobserve(entry.target);
							}
						}
					}
				}
			}
		});
	}, {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0.1,
	});

	targetSections.forEach((section) => {
		stopAutoplayObserver.observe(section);
	});

	// LOOK2、LOOK5、LOOK10、LOOK13用：表示されたら回転クラスを追加、回転完了後に停止
	const rotateTargetSections = document.querySelectorAll('.style2, .style5, .style10, .style13');
	const rotateObserver = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				const slideRotate = entry.target.querySelector('.slide-rotate');
				if (slideRotate && !slideRotate.classList.contains('rotate')) {
					// 回転クラスを追加
					slideRotate.classList.add('rotate');
					// アニメーション完了後に停止
					const rotateImage = slideRotate.querySelector('.rotate-image');
					if (rotateImage) {
						rotateImage.addEventListener('animationend', function() {
							slideRotate.classList.remove('rotate');
							slideRotate.classList.add('stopped');
						}, { once: true });
					}
					rotateObserver.unobserve(entry.target);
				}
			}
		});
	}, {
		rootMargin: '0px 0px -10% 0px',
		threshold: 0.1,
	});

	rotateTargetSections.forEach((section) => {
		rotateObserver.observe(section);
	});

	// スクロールアニメーション;
	funcAnim();
});

const funcAnim = () => {
	const progressItems = document.querySelectorAll('.anim');
	const observeAction = (entries) => {
		entries.forEach((entry) => {
			if (entry.isIntersecting) {
				// console.log('きた');
				entry.target.classList.add('active');
			}
			// else {
			// 	// console.log('こない');
			// 	entry.target.classList.remove('active');
			// }
		});
	};

	const options = {
		// root: root,
		rootMargin: '0px 0px -10% 0px',
	};

	const obsever = new IntersectionObserver(observeAction, options);

	progressItems.forEach((target) => {
		obsever.observe(target);
	});
};
